import styles from './Sidebar.module.scss';
import SidebarItem from './SidebarItem';
import { sidebarNavData } from './SidebarNavData';
import { useLogoutUser } from '@/hooks/useLogoutUser.ts';

const SidebarItemList = () => {
  const { logoutUser, isLoading } = useLogoutUser();
  return (
    <ul className={styles.sidebar__list}>
      {sidebarNavData.map((item, index) => {
        return (
          <li
            key={index}
            className={styles.sidebar__list__item}
          >
            <SidebarItem item={item} />
          </li>
        );
      })}
      <li className={styles.sidebar__list__item}>
        <a
          className={`${styles.list__item__link}`}
          onClick={logoutUser}
        >
          <span>{isLoading ? 'Logging out...' : 'Log Out'}</span>
        </a>
      </li>
    </ul>
  );
};

export default SidebarItemList;
